import React, { useEffect, useState, useRef } from 'react';
import { isRERPortal as _isRERPortal } from 'rer-theme/helpers/utils';

const Chatbot = () => {
  const [loading, setLoading] = useState(true);
  const ImportedJSRef = useRef(null);

  let isRERPortal = _isRERPortal();

  const eventListener = () => {
    window?.Userbot?.({
      key: '6e881a2ec028bd66a016a9adbb89768f',
      customerToken: '7866',
      chat: { minified: false },
      app: {
        hostname: 'https://cdn.userbot.ai/widget-chat/dist',
        socket: 'ai.userbot.ai',
      },
    });
  };
  useEffect(() => {
    setLoading(true);
    const importJS = async () => {
      try {
        const { default: namedImport } = await import(`./userbot.js`);
        ImportedJSRef.current = namedImport;
      } catch (err) {
        throw err;
      } finally {
        setLoading(false);
      }
    };
    isRERPortal && importJS();
  }, []);

  useEffect(() => {
    let scriptSrc = null;

    if (isRERPortal && !loading && ImportedJSRef.current) {
      // <script src="https://cdn.userbot.ai/widget-chat/dist/userbot.js" type="text/javascript"></script>
      //<script type="text/javascript">
      // document.addEventListener('userbot.ready', function() {window.Userbot({"key": "6e881a2ec028bd66a016a9adbb89768f","customerToken":"7866","chat": { "minified": false },"app":{"hostname":"https://cdn.userbot.ai/widget-chat/dist","socket":"ai.userbot.ai"}});});
      // </script>

      document.addEventListener('userbot.ready', eventListener);
      scriptSrc = document.createElement('script');
      scriptSrc.type = 'text/javascript';
      scriptSrc.script = ImportedJSRef.current;

      document.body.appendChild(scriptSrc);

      if (window?.Userbot) {
        //caso in cui non scatta lo eventListener perchè il js è gia stato caricato perchè si era gia entrati in questo path
        eventListener();
      }

      return () => {
        if (scriptSrc) {
          window?.Userbot?.()?.destroy();
        }
      };
    }
  }, [loading, ImportedJSRef]);

  return <></>;
};

export default Chatbot;
